import OmniFood from "../../assets/OmniFood.png";
import Natorus from "../../assets/Natorus.png";
import Nexter from "../../assets/Nexter.png";
import Agency from "../../assets/Agency.png";
import Work4 from "../../assets/work4.jpg";
import Work5 from "../../assets/work5.jpg";

export const projectsData = [
  {
    id: 1,
    image: OmniFood,
    title: "OmniFood - Never Cook Again!",
    github: "https://github.com/shahadat-07/OmniFood",
    live: "https://omni-food-responsive-web.netlify.app/",
    category: "web design",
    technology: ["css grid", "css flexbox"],
  },
  {
    id: 2,
    image: Nexter,
    title: "Nexter - Ultimate Personal Freedom",
    category: "web design",
    github: "https://github.com/shahadat-07/Nexter",
    live: "https://nexter-web-07.netlify.app/",
    technology: ["css grid", "css flexbox", "scss"],
  },
  {
    id: 3,
    image: Natorus,
    title: "Natorus - Exciting tours for adventure",
    category: "web design",
    github: "https://github.com/shahadat-07/Natorus",
    live: "https://natorus.netlify.app/",
    technology: ["css-animation", "scss"],
  },
  {
    id: 4,
    image: Agency,
    title: "Agency",
    category: "web design",
    github: "https://github.com/shahadat-07/Agency/tree/main",
    live: "https://agency-07.netlify.app/",
    technology: ["Bootstrap 5", "scss"],
  },
  {
    id: 5,
    image: Work5,
    title: "Web design",
    category: "web",
    github: "",
    live: "",
    technology: ["html", "css", "css grid", "css flexbox", "scss"],
  },
];

export const projectsNav = [
  {
    name: "all",
  },
  {
    name: "web design",
  },
  {
    name: "web development",
  },
];
